
import { TitumDetails } from "titum-layouts/shared-components/TitumDetails";
import footer from "../../Assets/footer.png";
import "./billfooter.css"

const BillFooter = () => {
  return (
    <>
      <div>
      <div>
           
            
        </div>
        <div>
        <img src={footer} alt="footer" style={{ width: 450 }} />
        </div>
        <div className="col-12">
        <div style={{ fontSize:10, textAlign:"center"}}>You can now deposit to : A/C 185010001347 (HNB, Maruthamunai.)</div>
            <div
              style={{
                fontSize:10,
                textAlign: "center",
              }}
            >
              `{TitumDetails.SOLUTION_BY} | {TitumDetails.WEB} | {TitumDetails.EMAIL_ID}`
            </div></div>

       
      </div>
    </>
  );
};

export default BillFooter;
